import { motion } from "framer-motion";
import CustomLists from "@/components/elements/CustomLists/CustomLists";
import ImageWithContentLeft from "@/components/elements/ImageWithContent/ImageWithContentLeft";
import Paragraph from "@/components/elements/Paragraph/Paragraph";
import TitleBar from "@/components/elements/TitleBar/TitleBar";
import TitleWithContent from "@/components/elements/TitleWithContent/TitleWithContent";
import ListWithDescription from "@/components/elements/CustomLists/ListWithDescription";
import i1 from "@/assets/images/services/grouting.jpeg"

// Define fadeInUp animation configuration
const fadeInUp = {
  initial: { opacity: 0, y: 50 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 1, ease: "easeOut" },
  viewport: { once: false, amount: 0.2 },
};

const InjectionWaterproofing = () => {
  return (
    <>
      <div className="pb-0 px-4  2xl:px-40 xl:px-40 md:px-[3rem] my-[5rem]">
        <TitleBar title="Injection WaterProofing" />

        <ImageWithContentLeft
          title="Description"
          imageUrl={i1}
          content={
            <>
              <span className="span-text">Grouting Injection</span> is a procedure of pumping cement-based, polyurethane-based, epoxy-based, or acrylate-based material into damaged or cracked structures to securely seal leaks, repair compromised structures, and make them watertight again for the long term. Injection waterproofing represents a sophisticated approach to combating water infiltration in concrete structures.{" "}
              <span className="span-text">Unlike traditional methods</span> that rely on surface coatings or membranes, injection waterproofing penetrates the very heart of the structure, addressing vulnerabilities at their source. By injecting specialized waterproofing materials directly into cracks, voids, and porous areas, this technique creates a seamless barrier that fortifies the structure against water penetration, mitigating the risk of leaks, moisture damage, and structural decay.
            </>
          }
        />

        <motion.div {...fadeInUp}>
          <TitleWithContent title="Why Grouting Injection is Important">
            <Paragraph content="Grouting injection is a critical solution for restoring the integrity and waterproofing of structures. It ensures:" />
            <CustomLists
              items={[
                [
                  "Sealing of active water leaks",
                  "Structural reinforcement",
                  "Prevention of corrosion due to water ingress",
                  "Extension of the life of structures",
                  "Minimization of future maintenance and repair costs",
                ],
              ]}
            />
          </TitleWithContent>
        </motion.div>

        <motion.div {...fadeInUp}>
          <TitleWithContent title="Applications of Grouting Injection">
            <CustomLists
              items={[
                [
                  "Foundations",
                  "Basements",
                  "Ground floors",
                  "Walls",
                  "Tanks",
                  "Swimming pools",
                  "Places where communications are entered",
                ],
                [
                  "Cold seams",
                  "Expansion joints",
                  "Cracks",
                  "Interstory floors",
                  "Pits",
                  "Roofing floors",
                ],
              ]}
            />
          </TitleWithContent>
        </motion.div>

        <motion.div {...fadeInUp}>
          <TitleWithContent title="Types of Grouting Injection">
            <ListWithDescription
              layout="split"
              titleListType="disc"
              items={[
                {
                  title: "Polyurethane (PU) Injection Grouting",
                  content: [
                    "Used to stop active water leaks",
                    "Expands on contact with water to seal cracks",
                    "Ideal for basement walls, tunnels, and retaining walls",
                  ],
                },
                {
                  title: "Epoxy Injection Grouting",
                  content: [
                    "Structural crack repair (non-moving cracks)",
                    "Restores concrete strength and integrity",
                    "Used in load-bearing walls, beams, and columns",
                  ],
                },
                {
                  title: "Cementitious Grouting",
                  content: [
                    "Filling voids and cracks in concrete or masonry",
                    "Common in slab lifting, soil stabilization, or baseplate installation",
                  ],
                },
                {
                  title: "Chemical Grouting",
                  content: [
                    "Includes silicate, acrylate, or resin-based grouts",
                    "Used for soil stabilization or water sealing in granular soils",
                  ],
                },
              ]}
            />
          </TitleWithContent>
        </motion.div>

        <motion.div {...fadeInUp}>
          <TitleWithContent title="Grouting Injection Process">
            <ListWithDescription
              layout="stacked"
              titleListType="decimal"
              items={[
                {
                  title: "Inspection and Crack Mapping",
                  content: ["Identify all visible cracks, voids, or leakage points."],
                },
                {
                  title: "Drilling Injection Ports",
                  content: ["Holes are drilled at suitable angles along the crack path"],
                },
                {
                  title: "Placement of Joint Filler",
                  content: ["Injection ports (called packers) are inserted into the drilled holes."],
                },
                {
                  title: "Grout Injection",
                  content: ["Grout is injected using a pump under controlled pressure."],
                },
                {
                  title: "Curing and Surface Finishings",
                  content: ["The surface is cleaned, sealed, or patched after curing."],
                },
              ]}
            />
          </TitleWithContent>
        </motion.div>

        <motion.div {...fadeInUp}>
          <TitleWithContent title="Why Choose Us for Grouting Injection Services?">
              <Paragraph
              content={
                  <>
                  At <span className="span-text">Sheel Waterproofing</span>, we combine advanced technology, skilled technicians, and premium-grade materials to deliver reliable, long-lasting grouting injection solutions. Whether you're dealing with active water leaks or structural cracks, we customize our approach to suit your specific needs—ensuring both performance and durability.
                  </>
              }
              />
              <CustomLists
              listStyle="none"
              layout="stacked"
              items={[
                  [
                  'Sealing of active water leaks',
                  'Structural reinforcement',
                  'Prevention of corrosion due to water ingress',
                  'Extension of the life of structures',
                  'Minimization of future maintenance and repair costs',
                  ],
              ]}
              bullets={[["💧", "🛠️", "🛡️", "⏳", "💰"]]}
              />
              <Paragraph
              content={
                  <>
                  Our grouting injection services offer a reliable, long-term solution to prevent further damage and extend the life of your property. With <span className="span-text">Sheel Waterproofing</span>, you can count on high-quality, durable results.
                  <br /><br />
                  <a href="/contact" className="text-custom-hov underline">Contact us today</a> for a free consultation or site inspection.
                  </>
              }
              />
            </TitleWithContent>
        </motion.div>

      </div>
    </>
  );
};

export default InjectionWaterproofing;
